import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'kmt-page',
  imports: [CommonModule, CardModule],
  templateUrl: './page.html',
  styleUrl: './page.css',
})
export class PageComponent {}
